import React from 'react';
import Widget from 'components/ui/layout/panel/Widget';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template no-modal">
        <Widget>
            <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: formatMessage({id: 'hybridCloud'})})}</h1>
            <p>{formatMessage({id: 'notAuthorized.hybridcloud.description1'})}</p>
            <p>{formatMessage({id: 'notAuthorized.hybridcloud.description2'})}<a href="https://www.equinix.com/interconnection-services/equinix-fabric" target="_blank" rel="noopener noreferrer" >Equinix Fabric</a>{formatMessage({id: 'notAuthorized.hybridcloud.description2.2'})}</p>
            <div class="badges">
                <a class="badges__link" href="https://www.equinix.com/interconnection-services/equinix-fabric" target="_blank" rel="noopener noreferrer"><img src={require('img/hybrid-cloud.png')} alt="Hybrid Cloud Services" width="65%"/></a>
            </div>
        </Widget>
        <Widget className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </Widget>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/publicCloud.js